<template>
  <WorkGenericPicker
    v-model="inputVal"
    v-bind="$props"
    :path="customPath ? customPath : 'products'"
    :item-text="customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :api-get-response-item-text="customItemText ? customItemText : (item) => defaultItemText(item)
    "
    :headers="internalHeaders"
    :load-generic-id="loadGenericId ? loadGenericId : _handleDefaultLoad"
    v-on="pickerListeners"
  >
    <template #header>
      <slot name="header">
        {{ $t('Components.sentences.chooseProduct') }}
      </slot>
    </template>

    <template #tooltip>
      <slot name="tooltip">
        {{ $t('Components.sentences.chooseProduct') }}
      </slot>
    </template>

    <template #filters>
      <slot name="filters">
        <w-row>
          <w-column cols="auto">
            <w-multiple-selection-filter-lazy
              :label="$t('Common.producer')"
              path="products/deliverycontacts"
              item-text="data.companyName"
              item-value="id"
              :get-data="(response) => response.data.data"
              clearable
              multiple
              searchKey="producer"
            />
          </w-column>

          <w-column cols="auto">
            <w-multiple-selection-filter-lazy
              :label="$t('Common.supplier')"
              path="products/deliverycontacts"
              item-text="data.companyName"
              item-value="id"
              :get-data="(response) => response.data.data"
              clearable
              multiple
              searchKey="supplier"
            />
          </w-column>

          <w-column cols="auto">
            <w-autocomplete
              :label="$t('Common.productUnit')"
              :items="productunits"
              item-text="data.label"
              item-value="id"
              searchKey="productUnit"
            />
          </w-column>

          <w-column cols="auto">
            <w-order-relation-input
              :label="$t('Common.basePrice')"
              searchKey="standardPrice"
            />
          </w-column>

          <w-column cols="auto">
            <WorkCategoryAndAttributeFilter
              searchKey="attributeCategory"
              :value-is-filter-state="true"
              use-category-table-filter
              use-attribute-table-filter
              :mandatory-filters="attributeMandatoryFilters"
            />
          </w-column>
        </w-row>
      </slot>
    </template>

    <template #item="{ item }">
      {{ defaultItemText(item) }}
    </template>

    <template #append-outer-actions>
      <slot name="append-outer-actions" />
    </template>
  </WorkGenericPicker>
</template>

<script>
// components
import WorkGenericPicker from '@/components/global_components/pickers/generic_picker/WorkGenericPicker';
import WorkCategoryAndAttributeFilter from '@/components/global_components/filters/WorkCategoryAndAttributeFilter';
// mixins
import genericPickerProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-props';
import genericPickerDialogProps from '@/components/global_components/pickers/generic_picker/mixins/generic-picker-dialog-props';
import staticData from '@/mixins/api_data/static-data-mixin';
// services and utils
import productService from '@/services/product-service';

export default {
  name: 'ProductPicker',
  components: {
    WorkGenericPicker,
    WorkCategoryAndAttributeFilter
  },
  props: {
    customPath: { type: String, required: false },
    customItemText: { type: [String, Function], required: false },
    exportComponent: { type: String, default: "ProductForm" },
    attributeMandatoryFilters: { type: Object, default: undefined }
  },
  mixins: [
    genericPickerProps,
    genericPickerDialogProps,
    staticData('productunits', 'productunits'),
  ],
  computed: {
    pickerListeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    internalHeaders() {
      if (this.headers) {
        return this.headers;
      }

      return [
        { text: this.$t('Common.matchcode'), value: 'matchCode' },
        { text: this.$t('Common.label'), value: 'label' },
        { text: this.$t('Common.unit'), value: 'baseUnitName' },
      ];
    },
  },
  methods: {
    async _handleDefaultLoad(productId) {
      let response = await productService.loadData(productId);
      return response.data;
    },
    defaultItemText(item) {
      return this.customItemText ? this.customItemText(item) : item?.data?.label
    },
  },
};
</script>
